import React from 'react';
import { useTranslation } from 'react-i18next';

// 定义ImageConfigOptions的属性接口
interface ImageConfigOptionsProps {
  quality: string;
  setQuality: (quality: string) => void;
  resolution: string;
  setResolution: (resolution: string) => void;
  imageSizes: string[];
}

const ImageConfigOptions: React.FC<ImageConfigOptionsProps> = ({
  quality,
  setQuality,
  resolution,
  setResolution,
  imageSizes
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-lg p-4 mb-4 transition-all duration-300 opacity-100">
      {/* 标题 */}
      <h3 className="text-sm font-medium text-white mb-3">{t('inputBar.imageConfig.title')}</h3>

      <div className="grid grid-cols-2 gap-4">
        {/* 质量选择 */}
        <div className="flex flex-col">
          <label className="block text-xs font-medium text-gray-300 mb-1">{t('inputBar.imageConfig.quality')}</label>
          <div className="relative">
            <select
              className="w-full bg-gray-800/95 backdrop-blur-sm border border-gray-700/50 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 active:bg-transparent active:outline-none focus:bg-transparent focus:outline-none focus-visible:bg-transparent focus-visible:outline-none appearance-none"
              value={quality}
              onChange={(e) => setQuality(e.target.value)}
            >
              <option value="standard">{t('inputBar.imageConfig.standard')}</option>
              <option value="hd">{t('inputBar.imageConfig.hd')}</option>
            </select>
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-400"></div>
          </div>
        </div>

        {/* 分辨率选择 */}
        <div className="flex flex-col">
          <label className="block text-xs font-medium text-gray-300 mb-1">{t('inputBar.imageConfig.resolution')}</label>
          <div className="relative">
            <select
              className="w-full bg-gray-800/95 backdrop-blur-sm border border-gray-700/50 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 active:bg-transparent active:outline-none focus:bg-transparent focus:outline-none focus-visible:bg-transparent focus-visible:outline-none appearance-none"
              value={resolution}
              onChange={(e) => setResolution(e.target.value)}
              disabled={imageSizes.length === 0}
            >
              {imageSizes.length > 0 ? (
                imageSizes.map(size => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))
              ) : (
                <option value="loading">{t('inputBar.imageConfig.loading')}</option>
              )}
            </select>
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-400"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageConfigOptions;
